var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { IndicatorBlockLayout } from '../entities/indicator-block-layout';
import { SegmentBar } from '../elements/segment-bar';
import { useInViewEffect } from '../hooks/use-in-view-effect';
import { useView } from '../hooks/use-view';
var cls = classNames('indicator-layout-bar-chart');
var IndicatorLayoutBarChartDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var IndicatorBlockStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SegmentBarStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 70%;\n  "], ["\n    width: 70%;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'IndicatorLayoutBarChart',
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  IndicatorBlock: styled(IndicatorBlockLayout)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), IndicatorBlockStyles),
  SegmentBar: styled(SegmentBar)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), SegmentBarStyles)
};
export var IndicatorLayoutBarChart = function (props) {
  var componentProps = useComponentProps(My.NAME, IndicatorLayoutBarChartDefaultProps, props);
  var className = componentProps.className,
    entity = componentProps.entity;
  var result = entity.result;
  var activeView = useView(entity.path).activeView;
  var animate = activeView === 'overview';
  var _a = __read(React.useState(animate ? 0 : result === null || result === void 0 ? void 0 : result.numericValue), 2),
    value = _a[0],
    setValue = _a[1];
  var ref = useInViewEffect(function () {
    setValue(result === null || result === void 0 ? void 0 : result.numericValue);
  }, {
    threshold: 0.5,
    rootMargin: '0px'
  });
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, React.createElement(My.IndicatorBlock, {
    entity: entity,
    dataViz: React.createElement(My.SegmentBar, {
      animate: animate,
      value: value,
      color: "#ADAD91"
    })
  }));
};
IndicatorLayoutBarChart.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;